/**
 * Ponto de registro de cada forma de partícula do `shape.swf` do legado, por número da forma (`ParticalShap<n>`): `[ox, oy, largura, altura]`.
 * `ox` e `oy` dizem onde a origem do símbolo cai dentro do quadro inteiro, em px; o atlas guarda o quadro aparado e perde esse ponto. Largura e altura são as da
 * soma das formas (conferem com o `sourceSize` do atlas). Gerado por `tools/extrair-formas-particulas.mjs`. Não edite à mão.
 */
export const PARTICLE_SHAPE_ORIGIN: Readonly<Record<number, readonly [ox: number, oy: number, w: number, h: number]>> = {
  1: [32.15, 39.6, 82.95, 79.95],
  2: [39.95, 31.95, 79.95, 63.95],
  3: [20.2, 15.9, 40.45, 35.75],
  4: [49.95, 49.95, 99.95, 99.95],
  5: [76.95, 76.95, 153.95, 153.95],
  6: [136, 18.15, 153.95, 37.95],
  7: [16.95, 16.45, 33.95, 32.95],
  8: [24.95, 24.95, 49.95, 49.95],
  9: [38.45, 38.45, 76.95, 76.95],
  10: [38.45, 38.45, 76.95, 76.95],
  11: [34.95, 34.95, 69.95, 69.95],
  12: [39.95, 39.95, 79.95, 79.95],
  13: [11.95, 11.95, 23.95, 23.95],
  14: [38.45, 38.45, 76.95, 76.95],
  15: [38.45, 38.45, 76.95, 76.95],
  16: [13.55, 13.55, 27.1, 27.1],
  17: [38.45, 38.45, 76.95, 76.95],
  18: [37.55, 60.3, 76.95, 76.95],
  19: [63.95, 63.95, 127.95, 127.95],
  20: [76.95, 76.95, 153.95, 153.95],
  21: [11.3, 14.05, 12.5, 15.75],
  22: [4.85, 5.45, 9.7, 10.95],
  23: [1.65, 1.65, 3.35, 3.35],
  24: [1.55, 3.3, 3.15, 6.6],
  25: [63.3, 28.3, 89.45, 57.15],
  26: [120, 105, 249.9, 199.9],
  27: [38.2, 8.95, 43.95, 17.95],
  28: [53.65, 12.3, 59.7, 24.25],
  29: [20.45, 20.45, 40.95, 40.95],
  30: [21.45, 23.45, 30.35, 42.5],
  31: [21.45, 23.45, 42.95, 46.95],
  32: [21.95, 23.45, 43.95, 46.95],
  33: [29.95, 29.95, 59.95, 59.95],
  34: [25.45, 22.45, 50.95, 44.95],
  35: [14.95, 14.95, 29.95, 29.95],
  36: [6, 6, 11.95, 11.95],
  37: [67.95, 26.95, 92.1, 54.65],
  38: [14.95, 14.45, 29.95, 28.95],
  39: [17.45, 14.95, 34.95, 29.95],
  40: [30.8, 23.5, 56.95, 53.95],
  41: [31.8, 25.2, 57.7, 54.65],
  42: [66.1, 26.55, 90.1, 54.65],
  43: [29.35, 19.85, 47.55, 39.45],
  44: [27.15, 29.75, 55.65, 54.65],
  45: [16.45, 20.05, 32.35, 38.45],
  46: [20.05, 23.4, 44.5, 49.6],
  47: [29, 34.2, 50.6, 66.8],
  48: [22.3, 33.1, 46.55, 46.55],
  49: [38.2, 30.2, 58.7, 50.5],
  50: [25.25, 26.75, 51.6, 50.6],
  51: [15.55, 16.4, 32.35, 30.35],
  52: [47.5, 4.65, 52, 9],
  53: [78.5, 26.95, 101, 46.45],
  54: [24.95, 11.45, 49.95, 22.95],
  55: [34.45, 21.45, 68.95, 42.95],
  56: [34.9, 36.5, 70.85, 73.9],
  57: [28.75, 11.1, 35.5, 24.25],
  58: [37.2, 43.45, 63.75, 87.05],
  59: [27.3, 30.35, 54.65, 60.7],
  60: [38.75, 47.05, 90.1, 94.15],
  61: [11.4, 10.65, 22.8, 21.35],
  62: [45, 35.65, 76.95, 76.95],
  63: [20, 22, 40.45, 41.5],
  64: [25.3, 31.35, 50.6, 62.75],
  65: [27.4, 29.6, 54.65, 60.7],
  66: [40.25, 47.75, 90.1, 94.15],
  67: [37.15, 28.95, 59.95, 53.25],
  68: [27.9, 24.9, 55.65, 49.6],
  69: [57.9, 14.9, 59.95, 24.95],
  70: [18.5, 12.5, 37, 25],
  71: [7.5, 7.5, 15, 15],
  74: [14, 19, 30.35, 39.45],
  75: [18, 22, 33.4, 43.5],
  76: [24, 31, 54.65, 59.7],
  77: [26, 34, 55.65, 62.75],
  78: [26, 30, 55.65, 55.65],
  79: [30, 33, 61.75, 62.75],
  80: [57, 59, 117.4, 110.3],
  81: [72, 75, 134.6, 136.65],
  82: [85, 20, 101.2, 40.45],
  83: [84, 20, 101.2, 40.45],
  84: [46.2, 10.15, 54.95, 21.95],
  85: [17, 10.75, 29.05, 21.65],
  86: [57, 20, 68.8, 38.45],
  87: [64, 21, 71.85, 39.45],
  88: [27, 22, 53.65, 39.45],
  89: [26, 33, 50.6, 62.75],
  90: [25, 37, 53.65, 69.85],
  91: [14, 13, 26.3, 24.25],
  92: [19, 25, 40.45, 48.55],
  93: [36, 47, 60.7, 74.9],
  94: [57.95, 46, 94.15, 79.95],
  95: [62.95, 54, 102.2, 90.1],
  96: [61.95, 53, 100.2, 91.1],
};

/** `displayCreator` (índice em `ParticalShapLib.data`) para o número da forma `ParticalShap<n>`. Índice fora da lista desenha um círculo preto, invisível em modo aditivo. */
export const PARTICLE_SHAPE_CLASS: readonly number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96];

